<div class="btn-container d-flex justify-content-end">
    <app-action-buttons [searchLabel]="'Export PDF'" [isSubmitLoading]="isLoading" [isSubmitDisabled]="isLoading" (onSubmit)="SavePDF()" [showDiscard]="false"></app-action-buttons>
</div>
<div #content id="htmlData" class="container" style="direction: rtl;">

   
    <div class=" d-flex flex-column align-items-center">
        <h1>فاتوره</h1>
        <span class="bold-text">رقم الفاتوره: <span style="direction: ltr;">#{{data.BillId}}</span> </span>
        
        <span class="bold-text">أسم العميل: {{username}}</span>
        <span class="bold-text">العنوان</span>
    </div>
    
    <div class="d-flex justify-content-between w-70">
        <span class="bold-text">تاريخ: {{data.cards[0].SellingDate | date: 'dd/MM/yyyy'}}</span>
        <span class="bold-text">الوقت: {{data.cards[0].SellingTime }}</span>
    </div>
    
    <div class="d-flex justify-content-start w-100">
        <p class="bold-text">الرقم الضريبى: 310305072500003</p>
    </div>
    

    <hr style="border-top:dashed 2px #000000a6">
    <div class="d-flex">
        <span style="width: 70%;">المنتجات</span>
        <span style="width: 15%;">الكميه</span>
        <span style="width: 15%;">السعر</span>
    </div>
    
    <hr style="border-top:dashed 2px #000000a6">
    <ng-container>
        <div class="d-flex" *ngFor="let card of data.cards">
            <span style="width: 70%;">{{card.CardName}}</span>
            <span style="width: 15%;">1</span>
            <span style="width: 15%;">{{card.Price?? '--'}}</span>
        </div>
    </ng-container>
    <hr style="border-top:dashed 2px #000000a6">

    <!-- <table class="table">
        <thead>
            <tr>
                <th class="bold-text" style="width: 70%;">المنتجات</th>
                <th class="bold-text"> الكميه</th>
                <th class="bold-text"> السعر</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let card of data.cards">
            <td style="width: 70%;">{{card.CardName}}</td>
            <td>1</td>
            <td>{{card.Price}}</td>
            </tr>
        </tbody>
    </table> -->
    <!-- <hr style="border-top:dashed 2px #000000"> -->
    
    <div class="d-flex">
        <span class="bold-text">المجموع (ريال): {{data.UserTotalPaid}}</span>
    </div>
    <div class="d-flex mt-3">
        <span class="bold-text">يشمل ضريبة القيمه المضافة (5%): {{data.UserTotalPaid}}</span>
    </div>
    
    <div class="d-flex justify-content-center mt-3">
        <span class="bold-text">>>>>>>>>>>>>>>اغلاق الفاتورة #{{data.BillId}}<<<<<<<<<<<<<<</span>
    </div>
</div>